
import { ExternalLinks } from '@/config';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IncidentBanner',
  computed: {
    URI_DOCTORS_INCIDENT_INFO: () => ExternalLinks.MYDR_INCIDENT_INFO,
    URI_PATIENTS_INCIDENT_INFO: () => ExternalLinks.MYDR_PATIENT_INCIDENT_INFO,
    dict() {
      return this.$i.tr().incidentBanner;
    },
  },
});
